import { Sparkles } from "lucide-react";

export const HeroSection = ({ theme, userProfile, onAskCoach, onExploreTheme }) => {
  const getGreeting = () => {
    const hour = new Date().getHours();
    if (hour < 12) return "Good morning";
    if (hour < 18) return "Good afternoon";
    return "Good evening";
  };

  const getRoleLabel = () => {
    return userProfile === "leader" ? "Leader" : "Team Member";
  };

  return (
    <section
      className="relative rounded-xl overflow-hidden"
      data-testid="hero-section"
    >
      <div className="absolute inset-0">
        <img
          src="https://images.pexels.com/photos/17483910/pexels-photo-17483910.png"
          alt=""
          className="w-full h-full object-cover opacity-30"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0A192F]/95 via-[#0A192F]/85 to-[#0A192F]/70" />
      </div>

      <div className="relative z-10 p-5 md:p-6">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <div className="flex-1 min-w-0">
            <div className="flex items-center gap-3 mb-2">
              <span className="inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full bg-[#14B8A6]/10 text-[#14B8A6] text-xs font-semibold tracking-wide uppercase" data-testid="theme-badge">
                <Sparkles className="w-3 h-3" />
                Monthly Theme
              </span>
            </div>
            <h2 className="font-headline text-xl sm:text-2xl font-light text-[#F8FAFC] tracking-tight" data-testid="hero-title">
              {getGreeting()}, <span className="font-medium">{getRoleLabel()}</span>
            </h2>
            {theme && (
              <p className="mt-1 text-sm text-[#94A3B8] max-w-xl leading-relaxed" data-testid="theme-summary">
                <span className="text-[#14B8A6] font-medium" data-testid="theme-title">{theme.title}</span>
                <span className="mx-1.5 text-white/20">|</span>
                {theme.summary}
              </p>
            )}
          </div>

          <div className="flex items-center gap-3 flex-shrink-0">
            <button
              onClick={onAskCoach}
              className="btn-primary px-4 py-2 rounded-md text-sm transition-all hover:shadow-lg hover:shadow-[#14B8A6]/10 active:scale-95"
              data-testid="hero-cta-coach"
            >
              Ask AI Coach
            </button>
            <button
              onClick={onExploreTheme}
              className="px-4 py-2 rounded-md text-sm transition-all active:scale-95 border border-[#14B8A6]/40 text-[#14B8A6] hover:bg-[#14B8A6]/10"
              data-testid="hero-cta-explore"
            >
              Browse Learning
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};
